import React from "react";
import {SvgIcon, SvgIconProps} from "@mui/material";

const BullButterflySvg = (props: any) => (<svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg" >
        <path d="M1.02067 1V33" stroke="#88888866" strokeOpacity="0.4" strokeLinecap="round" strokeDasharray="5 5"/>
        <path d="M1 18.0226H33" stroke="#88888866" strokeOpacity="0.4" strokeLinecap="round" strokeDasharray="5 5"/>
        <path d="M31.9251 23.5735H28.1628L27.203 18.0226M1.28941 23.5735H20.907L21.6748 18.0226" stroke="#A40C0C" strokeWidth="2"/>
        <path d="M21.6748 18.0226L24.1318 1.37006L27.2031 18.0226" stroke="#089981" strokeWidth="2"/>
    </svg>)
const BullButterfly: React.FC<SvgIconProps> = React.memo((props) => (
    <SvgIcon {...props}>
        {BullButterflySvg(props)}
    </SvgIcon>
));
export default BullButterfly